<script setup>
import Sidebar from "@/components/navigation/Sidebar.vue";
import PrivateHeader from '@/components/navigation/PrivateHeader.vue';
</script>

<template>

    <!--
      h-dvh, not h-screen: 100vh on iOS is the *expanded*-toolbar height, so the bottom of every
      page sat under the browser chrome. dvh tracks the visible viewport and is identical to vh on
      desktop. index.html carries viewport-fit=cover, so the safe-area insets below are live and
      keep the header clear of the notch and the shell clear of the home indicator.
    -->
    <div class="private-shell flex flex-col h-dvh bg-base-200">

        <!-- Keyboard users had no way past the header and the whole product menu on every route. -->
        <a
            href="#main-content"
            class="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[100] focus:rounded focus:bg-base-100 focus:px-4 focus:py-2 focus:no-underline focus:shadow-lg"
        >Skip to main content</a>

        <div class="bg-base-100 border-b shadow flex flex-col">

            <div class="flex flex-col px-2 sm:px-3 lg:px-4">
                <PrivateHeader />
            </div>

        </div>

        <div class="flex flex-1 overflow-y-hidden">

            <Sidebar />

            <!-- overscroll-contain stops end-of-scroll chaining out to the document on iOS. -->
            <main id="main-content" tabindex="-1" class="flex-1 min-w-0 overflow-y-auto overscroll-contain m-4 gap-4">

                <slot></slot>

            </main>

        </div>

    </div>

</template>

<style scoped>
/*
  Safe-area handling for the notch (landscape) and the home indicator (portrait).
  max() so a device with no inset keeps the existing spacing rather than collapsing to 0.
*/
.private-shell {
    padding-top: env(safe-area-inset-top, 0px);
    padding-left: env(safe-area-inset-left, 0px);
    padding-right: env(safe-area-inset-right, 0px);
    padding-bottom: env(safe-area-inset-bottom, 0px);
}
</style>
